import { useParams } from "react-router-dom";
import { ShowById } from "src/components/ShowById";

export function ShowInspectionDeviationById() {
  const { deviationId } = useParams();
  return <ShowById id={deviationId || ""} />;
}
